import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditCostRequestFailure({ uuid }) {
      const req = getState().find(({ cost }) => cost.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditCostRequestPending({ uuid }) {
      const req = getState().find(({ cost }) => cost.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditCostRequestSuccess({ uuid }) {
      const req = getState().find(({ cost }) => cost.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
